<template>
  <div id="app" data-app>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  components: {
  },

  data(){
    return{
      
    }
  }
};
</script>

<style>
</style>